<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.prefix" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="prefix" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.postfix" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="postfix" />
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.inline" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="inline" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="6" sm12 xs24 v-for="(item, index) in stats" :key="index">
        <card>
          <card-text>
            <stats :inline="inline" :class="['select-none']">
              <stats-label v-html="item.label" :class="['opacity-70', inline ? 'mr-2' : null]" /><!--
              --><divider :class="['my-1']" v-if="!inline" /><!--
              --><stats-value :prefix="prefix ? item.prefix : null" :postfix="postfix ? item.postfix : null">
                <template v-slot:icon v-if="icon">
                  <icon :name="item.icon" :size=".85" :class="['mr-1']" />
                </template>{{ item.value }}
              </stats-value>
            </stats>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageStats',
  mixins: [
    methods
  ],
  data () {
    return {
      stats: [],
      icon: true,
      inline: false,
      prefix: true,
      postfix: true
    }
  },
  mounted () {
    this.getExternalData('stats.json', 'stats')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/stats.vue